// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"6c5e219d","714":"b4e13c24","787":"70a8d3a9","794":"b96298d1","795":"ea1b5a68","877":"e2e532d1","994":"38b3d4fb"}[chunkId] + ".chunk.js";
};